/* MINOTI 28.10.2026: sale references come only from the variant-specific Complimus prior-price widget. No compare-at fallback. Failed or missing probes leave the current price without a discount claim. Cache is page-local and expires after one minute. */
(function () {
  if (window.mnSaleTiles) return;
  window.mnSaleTiles = true;

  var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var SALE = { pl: 'Wyprzedaż', de: 'Sale', fr: 'Soldes', it: 'Saldi', es: 'Rebajas', nl: 'Sale' }[lang] || 'Sale';
  var theme = window.Shopify && window.Shopify.theme;
  var preview = theme && theme.role && theme.role !== 'main' ? '&preview_theme_id=' + theme.id : '';
  var PRIOR = { pl: 'Najniższa cena z 30 dni przed obniżką:', de: 'Niedrigster Preis in den 30 Tagen vor der Preissenkung:', fr: 'Prix le plus bas des 30 jours avant la réduction :', it: 'Prezzo più basso nei 30 giorni precedenti lo sconto:', es: 'Precio más bajo en los 30 días anteriores a la rebaja:', nl: 'Laagste prijs in de 30 dagen vóór de korting:' }[lang] || 'Lowest price in the 30 days before the discount:';
  var cache = {};

  /* "1.234,56 zł", "€139.90", "CHF 139.90", "139,90 €" -> liczba */
  function num(s) {
    s = String(s || '').replace(/[^\d.,]/g, '').replace(/^[.,]+|[.,]+$/g, '');
    if (!s) return NaN;
    var last = Math.max(s.lastIndexOf(','), s.lastIndexOf('.'));
    if (last > -1 && s.length - last - 1 === 2) {
      return parseFloat(s.slice(0, last).replace(/[.,]/g, '') + '.' + s.slice(last + 1));
    }
    return parseFloat(s.replace(/[.,]/g, ''));
  }

  function probe(url, vid) {
    var key = lang + '|' + url + '|' + vid;
    if (cache[key] && Date.now() - cache[key].time < 60000) return cache[key].promise;
    var src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + encodeURIComponent(vid) + '&view=omnibus-probe' + preview;
    var request = fetch(src, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) {
        var m = t.match(/omnibus-price__price">\s*([^<]+?)\s*</);
        var v = m ? m[1].replace(/&nbsp;/g, ' ') : '';
        return v;
      })
      .catch(function () { delete cache[key]; return ''; });
    cache[key] = { time: Date.now(), promise: request };
    return request;
  }

  function saleReference(price, lowText) {
    var base = num(lowText);
    if (!isFinite(price) || !(base > price) || price < 0) return null;
    var pct = Math.floor(((base - price) / base) * 100);
    return pct >= 1 ? { text: lowText, percent: pct } : null;
  }

  function clear(tile) {
    tile.querySelectorAll('[data-mn-sale-x]').forEach(function (n) { n.remove(); });
    var neu = tile.querySelector('[data-mn-new]');
    if (neu && neu.dataset.mnSaleHid === '1') { neu.hidden = false; delete neu.dataset.mnSaleHid; }
    tile.classList.remove('mnt--sale');
  }

  function apply(tile) {
    var amt = tile.querySelector('[data-mn-amount]');
    if (!amt) return;
    var shown = amt.textContent.trim();
    var link = tile.querySelector('[data-mn-title-link]') || tile.querySelector('a[href*="/products/"]');
    if (!link) return;
    var url = link.getAttribute('href').split('?')[0].split('#')[0];
    var price = num(shown);

    var vid = '';
    var btns = tile.querySelectorAll('[data-vid]');
    for (var i = 0; i < btns.length; i++) {
      if (!btns[i].disabled && (btns[i].getAttribute('data-variant-price') || '').trim() === shown) { vid = btns[i].getAttribute('data-vid'); break; }
    }
    if (!vid) {
      for (var j = 0; j < btns.length; j++) {
        if ((btns[j].getAttribute('data-variant-price') || '').trim() === shown) { vid = btns[j].getAttribute('data-vid'); break; }
      }
    }
    var identity = url + '|' + vid + '|' + shown + '|' + amt.classList.contains('mnt__amount--sale');
    if (tile.dataset.mnSaleFor === identity) return;
    tile.dataset.mnSaleFor = identity;
    clear(tile);
    tile.querySelectorAll('[data-mn-was]').forEach(function (n) { n.remove(); });
    if (!amt.classList.contains('mnt__amount--sale')) return;
    if (!vid) return;

    probe(url, vid).then(function (lowText) {
      if (tile.dataset.mnSaleFor !== identity) return;
      var reference = saleReference(price, lowText);
      if (!reference) return;
      var baseText = reference.text;
      var pct = reference.percent;

      badge(tile);

      var was = document.createElement('s');
      was.className = 'mnt__was mnt__was--omni';
      was.setAttribute('data-mn-sale-x', '');
      was.textContent = baseText;
      amt.after(was);

      var off = document.createElement('span');
      off.className = 'mnt__off';
      off.setAttribute('data-mn-sale-x', '');
      off.textContent = '−' + pct + '%';
      was.after(off);

      var note = document.createElement('span');
      note.className = 'mnt__prior';
      note.setAttribute('data-mn-sale-x', '');
      note.textContent = PRIOR + ' ' + baseText;
      tile.querySelector('[data-mn-price]').appendChild(note);
    });
  }

  function badge(tile) {
    if (tile.querySelector('.mnt__sale')) return;
    var labels = tile.querySelector('.mn-product-labels');
    if (labels) {
      var b = document.createElement('span');
      b.className = 'mnt__sale';
      b.setAttribute('data-mn-sale-x', '');
      b.textContent = SALE.toLocaleUpperCase(document.documentElement.lang || undefined);
      labels.prepend(b);
      var neu = labels.querySelector('[data-mn-new]');
      if (neu && !neu.hidden) { neu.hidden = true; neu.dataset.mnSaleHid = '1'; }
    }
    tile.classList.add('mnt--sale');
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { io.unobserve(e.target); apply(e.target); watch(e.target); }
    });
  }, { rootMargin: '400px 0px' }) : null;

  /* podmiana koloru w kafelku przepisuje cene: liczymy od nowa */
  function watch(tile) {
    if (tile.dataset.mnSaleWatch) return;
    tile.dataset.mnSaleWatch = '1';
    var price = tile.querySelector('[data-mn-price]');
    if (!price || !window.MutationObserver) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { apply(tile); }, 60);
    }).observe(tile, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'href', 'data-vid', 'data-variant-price'] });
  }

  function scan(root) {
    (root || document).querySelectorAll('article.mnt[data-mn-tile]:not([data-mn-sale-seen])').forEach(function (tile) {
      tile.setAttribute('data-mn-sale-seen', '');
      if (io) io.observe(tile); else { apply(tile); watch(tile); }
    });
  }

  function start() {
    scan(document);
    if (window.MutationObserver) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { scan(document); }, 120); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
